import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName, I18nText } from '../../../../../types';
import {
  OperationClientID,
  FetchOperationsCacheKey
} from '../../../operationsTypes';

import { useToastNotification } from '../../../../../common/hooks/useToastNotification';
import { useNoTATForm } from '../../forms/NoTATForm/hooks/useNoTATForm';

import { NoTATForm } from '../../forms/NoTATForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';

import { operationsKeys, words } from '../../../../../locales/keys';

const NO_TAT_FORM = 'no-tat-form';
const NO_TAT_BUTTON = 'no-tat-button';

interface NoTATModalButtonProps {
  clientId: OperationClientID;
  cacheKeys?: FetchOperationsCacheKey[];
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  withToastOnSuccess?: boolean;
  disabled?: boolean;
}

function NoTATModalButton({
  clientId,
  cacheKeys,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  withToastOnSuccess,
  disabled
}: NoTATModalButtonProps) {
  const { showToastI18nNotification } = useToastNotification({
    appearance: 'success',
    i18nMessage: operationsKeys.recordAdded
  });

  const {
    validationErrors,
    registerFields,
    handleLeaveOfAbsence,
    resetNoTATForm,
    createOperationReset,
    createOperationLoading,
    createOperationErrorMessage,
    control
  } = useNoTATForm({
    cacheKeys,
    clientId,
    onSuccess: withToastOnSuccess ? showToastI18nNotification : undefined
  });

  return (
    <FormModalButton
      className={className}
      form={NO_TAT_FORM}
      dataGa={NO_TAT_BUTTON}
      i18nTitle={operationsKeys.noTat}
      i18nText={i18nText || words.create}
      i18nTextClassName={i18nTextClassName}
      i18nSubmitText={operationsKeys.addRecord}
      icon={icon}
      iconClassName={iconClassName}
      onOpen={resetNoTATForm}
      isLoading={createOperationLoading}
      onClose={createOperationReset}
      onSubmit={handleLeaveOfAbsence}
      disabled={disabled}
    >
      <NoTATForm
        form={NO_TAT_FORM}
        isLoading={createOperationLoading}
        control={control}
        registerSubject={registerFields.registerSubject}
        subjectValidationError={validationErrors.subjectValidationError}
        bodyValidationError={validationErrors.bodyValidationError}
        dateValidationError={validationErrors.dateValidationError}
        completeDatetimeValidationError={
          validationErrors.completeDatetimeValidationError
        }
      />

      <div className="px-4">
        <AlertMessage message={createOperationErrorMessage} />
      </div>
    </FormModalButton>
  );
}

export default NoTATModalButton;
